<template>
  <v-switch v-model="$vuetify.theme.dark" inset dark dense>
    <template #label>
      <span class="white--text">Theme Dark</span>
    </template>
  </v-switch>
</template>

<script>
export default {
  name: 'AppSwitchTheme',
};
</script>
